export const MODIFY_MCP_MENU_ITEM = "MODIFY_MCP_MENU_ITEM";

export function modifyMcpMenuItem(mcpMenuItem) {
    return {
        type: MODIFY_MCP_MENU_ITEM,
        mainState: {
            mcpMenuItem: mcpMenuItem
        }
    }
}